import { Component, OnInit } from '@angular/core';
import { TimeReport } from '../time-admin/TimeReport';
import { SummaryReport } from '../time-admin/SummaryReport';
import { EEList } from 'src/app/time-admin/eeList';

import { TimeServiceService } from 'src/app/services/time-service.service';

import { $ } from 'protractor';

@Component({
  selector: 'app-time-admin',
  templateUrl: './time-admin.component.html',
  styleUrls: ['./time-admin.component.scss']
})
export class TimeAdminComponent implements OnInit {
  startDate: Date;
  endDate: Date;
  infoBox: string;
  showSummary = false;
  eeSelected = 0;
  timeExpand = '';
  timeReport: TimeReport[];
  summaryReport: SummaryReport[];
  eeList: EEList[] = [
    { FULLNAME: 'Lloyd Miller', EEID: 1 },
    { FULLNAME: 'Kato Estell', EEID: 2 },
    { FULLNAME: 'Spunky Murphy', EEID: 3 }
  ];

  constructor(private timeService: TimeServiceService) { }

  ngOnInit(): void {
    this.getEEList();
  }

  updateDates() {

  }

  getEEList() {
    this.timeService.getEEList()
      .subscribe(
        res => { this.eeList = res; }
      );
  }

  getDetailReport() {
    if (this.startDate) {
      this.timeService.getTimeReport(this.startDate, this.endDate)
        .subscribe(
          res => {
            this.timeReport = res;
            this.getSummaryReport();
            this.showSummary = true;
            this.infoBox = '';
          }
        );
    } else {
      this.infoBox = 'Please Choose Start and End Dates for the Report.';
    }
  }

  getSummaryReport() {
    this.timeService.getSummaryReport(this.startDate, this.endDate)
      .subscribe(
        res => {
          this.summaryReport = res;
        }
      );
  }

  postLogTime() {
    if (this.eeSelected > 0) {
      this.timeService.postLogTime(this.eeSelected).subscribe(
        res => {
          this.summaryReport = res;
        },
        error => {
          console.log('postLogTime error:' + error);
        },
        () => {
          this.infoBox = 'Time Logged Successfully!';
        }
      );
    } else {
      this.infoBox = 'Please pick one employee to Clock In/Out.';
    }
  }


}
